import { c as _c } from "react/compiler-runtime";
import { storedAttributeProps } from "../html-attributes";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { getBlockquoteStyles } from "./styles";
interface Props {
  attrs: Record<string, unknown>;
  updateAttrs: (attrs: Record<string, unknown>) => void;
  selected: boolean;
}
export function BlockquoteTiptapView(t0) {
  const $ = _c(11);
  const {
    attrs,
    selected
  } = t0;
  const t1 = selected || undefined;
  let t2;
  if ($[0] !== attrs) {
    t2 = storedAttributeProps(attrs);
    $[0] = attrs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attrs) {
    t3 = getBlockquoteStyles(attrs);
    $[2] = attrs;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NodeViewContent />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3) {
    t5 = <div {...t2} style={t3}>{t4}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <NodeViewWrapper data-block-type="emailBlockquote" data-selected={t1}>{t5}</NodeViewWrapper>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}